/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
  const defaults$2 = {
      color: 'ash'
  };

 const loaders = {};
  function loadScript(options = {}) {
      if (!options.type) {
          options.type = 'json';
      }
      if (options.url) {
          if (loaders[options.url]) {
              return loaders[options.url];
          } else {
              return getScriptWithPromise(options.url, options.type);
          }
      } else if (options.json) {
          if (loaders[options.json]) {
              return Promise.resolve(loaders[options.json]);
          } else {
              const request = window.fetch(options.json).then((response)=>{
                  return response.json();
              }).then((response)=>{
                  loaders[options.json] = response;
                  return response;
              }).catch((error)=>{
                  loaders[options.json] = null;
              });
              loaders[options.json] = request;
              return request;
          }
      } else if (options.name) {
          const key = ''.concat(options.name, options.version);
          if (loaders[key]) {
              return loaders[key];
          } else {
              return loadShopifyWithPromise(options);
          }
      } else {
          return Promise.reject();
      }
  }
  function getScriptWithPromise(url, type) {
      const loader = new Promise((resolve, reject)=>{
          if (type === 'text') {
              fetch(url).then((response)=>response.text()
              ).then((data)=>{
                  resolve(data);
              }).catch((error)=>{
                  reject(error);
              });
          } else {
              getScript(url, function() {
                  resolve();
              }, function() {
                  reject();
              });
          }
      });
      loaders[url] = loader;
      return loader;
  }
  function loadShopifyWithPromise(options) {
      const key = ''.concat(options.name, options.version);
      const loader = new Promise((resolve, reject)=>{
          try {
              window.Shopify.loadFeatures([
                  {
                      name: options.name,
                      version: options.version,
                      onLoad: (err)=>{
                          onLoadFromShopify(resolve, reject, err);
                      }
                  }, 
              ]);
          } catch (err) {
              reject(err);
          }
      });
      loaders[key] = loader;
      return loader;
  }
  function onLoadFromShopify(resolve, reject, err) {
      if (err) {
          return reject(err);
      } else {
          return resolve();
      }
  }


  let ColorMatch = class ColorMatch {
      getColor() {
          return this.match;
      }
      init() {
          const getColors = loadScript({
              json: window.theme.assets.swatches
          });
          return getColors.then((colors)=>{
              return this.matchColors(colors, this.settings.color);
          }).catch((e)=>{
              console.log('failed to load swatch colors script');
              console.log(e);
          });
      }
      matchColors(colors, name) {
          let bg = '#E5E5E5';
          let img = null;
          const path = window.theme.assets.base || '/';
          const comparisonName = name.toLowerCase().replace(/\s/g, '');
          const array = colors.colors;
          if (array) {
              const variantNameMatch = (nameObject)=>{
                  const indexName = Object.keys(nameObject).toString();
                  const neatName = indexName.toLowerCase().replace(/\s/g, '');
                  return neatName === comparisonName;
              };
              const position = array.findIndex(variantNameMatch);
              if (position > -1) {
                  const value = Object.values(array[position])[0];
                  const valueLowerCase = value.toLowerCase();
                  if (valueLowerCase.includes('.jpg') || valueLowerCase.includes('.jpeg') || valueLowerCase.includes('.png') || valueLowerCase.includes('.svg')) {
                      img = `${path}${encodeURIComponent(value)}`;
                      bg = '#888888';
                  } else {
                      bg = value;
                  }
              }
          }
          return {
              color: this.settings.color,
              path: img,
              hex: bg
          };
      }
      constructor(options = {}){
          this.settings = {
              ...defaults$2,
              ...options
          };
          this.match = this.init();
      }
  };

  function waitForCustomVariant(callback) {
    const observer = new MutationObserver((mutations, obs) => {
      const wrappers = document.querySelectorAll('.radiant-custom-variant');
      if (wrappers.length > 0) {
        obs.disconnect(); // Stop observing
        callback(wrappers); // Pass the elements to your callback
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  waitForCustomVariant((wrappers) => {
    wrappers.forEach(wrapper => {
      const trigger = wrapper.querySelector('.radiant-variant-trigger');
      const select = document.getElementById(wrapper.dataset.rebuySelectId);
      const options = wrapper.querySelectorAll('.radiant-variant-option');

      // Toggle dropdown open/close
      trigger.addEventListener('click', () => {
        let openBlock = document.querySelector('.radiant-custom-variant.open');
        if (openBlock && openBlock != wrapper) {
          openBlock.classList.remove('open');
        }
        wrapper.classList.toggle('open');
      });

      // Button - swatch
      // Add swatch color
      let matcher = new ColorMatch({
          color: trigger.dataset.variantTitle
      });
      matcher.getColor().then((result)=>{
        let colorMatch = result;
        let element = trigger.querySelector('.swatch__button');

        if (!element) {
          return false;
        }
        
        if (colorMatch.hex) {
            element.style.setProperty('--swatch', `${colorMatch.hex}`);

            if(colorMatch.hex == '#ffffff') {
                element.classList.add('is-white')
            }
        }

        if (colorMatch.path) {
            element.style.setProperty('background-image', `url(${colorMatch.path})`);
            element.style.setProperty('background-size', 'cover');
        }
      });

      // Option click
      options.forEach(option => {
        // Add swatch color
        matcher = new ColorMatch({
            color: option.dataset.variantTitle
        });
        matcher.getColor().then((result)=>{
            let colorMatch = result;
            let element = option.querySelector('.swatch__button');

            if (!element) {
              return false;
            }
            
            if (colorMatch.hex) {
                element.style.setProperty('--swatch', `${colorMatch.hex}`);

                if(colorMatch.hex == '#ffffff') {
                    element.classList.add('is-white')
                }
            }

            if (colorMatch.path) {
                element.style.setProperty('background-image', `url(${colorMatch.path})`);
                element.style.setProperty('background-size', 'cover');
            }
        });

        // Add event listener
        option.addEventListener('click', () => {
          if (option.classList.contains('rebuy-product-options__option--oos')) return;

          // Update hidden select for Rebuy
          select.value = option.dataset.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));

          // Update button text
          trigger.innerHTML = option.innerHTML;

          // Close dropdown
          wrapper.classList.remove('open');
        });
      });
    });
  }, 2000);

})();
